(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionSortSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-sort-select]');
      this.select && this.select.addEventListener('change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', this.select.value);
        url.searchParams.delete('page');
        window.location.href = url;
      });
    }
  }

  if (!customElements.get('collection-sort-select')) {
    customElements.define('collection-sort-select', CollectionSortSelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const success = document.querySelector('.contact-form-panel [data-auto-dismiss]');
    if (!success) return;
    setTimeout(() => {
      success.classList.add('is-dismissing');
      setTimeout(() => success.remove(), 400);
    }, 4000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileMenuDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.openBtn = document.querySelector('[data-menu-open]');
      this.closeBtn = this.querySelector('[data-menu-close]');

      if (!this.dialog) return;

      this.openBtn && this.openBtn.addEventListener('click', () => this.open());
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });
    }

    open() {
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
    }

    close() {
      this.dialog.classList.remove('is-visible');
      const panel = this.dialog;
      const onEnd = () => {
        panel.removeEventListener('transitionend', onEnd);
        this.dialog.close();
      };
      panel.addEventListener('transitionend', onEnd);
    }
  }

  if (!customElements.get('mobile-menu-dialog')) {
    customElements.define('mobile-menu-dialog', MobileMenuDialog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.prevBtn = this.querySelector('[data-hero-prev]');
      this.nextBtn = this.querySelector('[data-hero-next]');
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.maybeStart());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.maybeStart());

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.maybeStart();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    maybeStart() {
      if (!this.autoplay || this.reducedMotion || this.slides.length <= 1) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class PasswordCountdown extends HTMLElement {
    connectedCallback() {
      const launch = this.dataset.launch;
      if (!launch) return;
      this.target = new Date(launch).getTime();
      if (Number.isNaN(this.target)) return;

      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const diff = Math.max(0, this.target - Date.now());
      const pad = (n) => String(n).padStart(2, '0');

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = pad(hours);
      this.minutesEl.textContent = pad(minutes);
      this.secondsEl.textContent = pad(seconds);

      if (diff === 0) clearInterval(this.timer);
    }
  }

  if (!customElements.get('password-countdown')) {
    customElements.define('password-countdown', PasswordCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductStickyBar extends HTMLElement {
    connectedCallback() {
      const enquireBtn = this.querySelector('[data-sticky-enquiry]');
      enquireBtn && enquireBtn.addEventListener('click', () => {
        const open = document.querySelector('[data-enquiry-open]');
        open && open.click();
      });
    }
  }

  if (!customElements.get('product-sticky-bar')) {
    customElements.define('product-sticky-bar', ProductStickyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
